<ng-container class="accountblock">
  <form [formGroup]="formRingi">
    <!-- <div class="card m-6">
    <h5 class="card-header">Ringi <span class="legend-label">{{requiredLegend}}</span></h5>
    <div class="card-body">

      <div class="form-group row">
        <label for="ringiChecked" class="col-sm-4 col-form-label">Will a ringi be required for
        implementation?</label>
        <label class="switch">
          <input id="ringiChecked" formControlName="ringiRequired" type="checkbox" (change)="ringiChecked($event)">
          <span class="slider round"></span>
        </label>
        <label class="slider-label">{{ringiRequiredYesNo}}</label>
      </div>
      <div class="form-group" *ngIf="isRingiChecked">
        <label for="email">If yes, please specify the project/ringi id and investment amount:</label>
        <div class="form-group row">
          <label for="ProjectRingiId" class="col-sm-3 p-1 col-form-label-textbox-center">Project/ringi id *</label>
          <div class="col-sm-3 p-1">
            <input type="text" formControlName="ringiNumber" class="form-control" placeholder="Project/ringi id" (keyup)="ringiNumberKeyUp($event)" (change)="ringiIdChanged($event)">

            <small class="invalid"
              *ngIf="((isRingiChecked  && formRingi.get('ringiNumber')?.touched ) && formRingi.get('ringiNumber')?.errors?.['required'])">Project/ringi
              id is required
            </small>
            <small class="invalid"
              *ngIf="(((isRingiChecked) && formRingi.get('ringiNumber')?.touched ) && formRingi.get('ringiNumber')?.errors?.['maxlength'])">Project/ringi
              id maximum length is 200 characters
            </small>
          </div>
          <label for="InvestmentAmount" class="col-sm-3 p-1 col-form-label-textbox-center">Investment amount * $</label>
          <div class="col-sm-3 p-1">

            <input type="text" formControlName="investmentAmount" class="form-control"  (keyup)="CommaFormatted($event)" (change)="invAmountChanged($event)"     placeholder="Investment amount">

            <small class="invalid"
              *ngIf="((isRingiChecked || formRingi.get('investmentAmount')?.touched) && formRingi.get('investmentAmount')?.errors?.required)">Investment
            amount is required</small>
          </div>
        </div>
      </div>

    </div>
  </div> -->


  <div class="card m-6">
    <h5 class="card-header">Ringi <span class="legend-label">{{requiredLegend}}</span></h5>
    <div class="card-body">

      <div class="form-group row">
        <label for="ringiChecked" class="col-sm-4 col-form-label">Will a ringi be required for
        implementation?</label>
        <label class="switch">
          <input id="ringiChecked" formControlName="ringiRequired" type="checkbox" (change)="ringiChecked($event)">
          <span class="slider round"></span>
        </label>
        <label for="ringiChecked"  class="slider-label">{{ringiRequiredYesNo}}</label>
      </div>
      @if (isRingiChecked) {
        <div class="form-group">
          <label for="email">If yes, please specify the project/ringi id and investment amount:</label>
          <div class="form-group row">
            <label for="NAMC" class="col-sm-2 p-1 col-form-label-textbox-center">Project/ringi id *</label>
            <div class="col-sm-2 p-1">
              <input type="text" formControlName="ringiNumber" class="form-control" placeholder="Project/ringi id" (change)="ringiIdChanged($event)">
              @if (((isRingiChecked  && formRingi.get('ringiNumber')?.touched ) && formRingi.get('ringiNumber')?.errors?.['required'])) {
                <small class="invalid"
                  >Project/ringi
                  id is required
                </small>
              }
              @if ((((isRingiChecked) && formRingi.get('ringiNumber')?.touched ) && formRingi.get('ringiNumber')?.errors?.['maxlength'])) {
                <small class="invalid"
                  >Project/ringi
                  id maximum length is 200 characters
                </small>
              }
            </div>
            <label for="NAMC" class="col-sm-3 p-1 col-form-label-textbox-center">Investment amount * $</label>
            <div class="col-sm-2 p-1">
              <input type="text" formControlName="investmentAmount" class="form-control"  (keyup)="CommaFormatted($event)" (change)="invAmountChanged($event)"     placeholder="Investment amount">
              @if (((isRingiChecked || formRingi.get('investmentAmount')?.touched) && formRingi.get('investmentAmount')?.errors?.required)) {
                <small class="invalid"
                  >Investment
                amount is required</small>
              }
            </div>
            <div class="col-sm-2 p-1">
              <select class="form-select" id="currency" formControlName="currencyID" (change)="changeAccountCurrency($event)">
                @for (currency of currencies; track currency) {
                  <option [value]="currency.currencyID">
                  {{currency.code}}</option>
                }
              </select>
            </div>
          </div>
        </div>
      }

    </div>
  </div>
</form>
</ng-container>
